import React, { useState } from "react";
import { Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const DECLINE_CHIPS = ["Missing information", "Not authorized for this team", "Duplicate request", "Please contact me first"];
const MAX = 300;

// Inline optional decline explanation: quick-pick chips + short text, then "Send decline".
export default function DeclineReasonBox({ busy, onSend, onCancel, testId = "decline-reason" }) {
  const [reason, setReason] = useState("");
  return (
    <div className="order-last w-full basis-full rounded-lg border border-red-200 bg-white p-3 shadow-sm animate-fade-in-up" data-testid={testId}>
      <p className="mb-2 text-xs font-semibold text-slate-600">Add a short reason <span className="font-normal text-slate-400">(optional, shared with the requester)</span></p>
      <div className="mb-2 flex flex-wrap gap-1.5">
        {DECLINE_CHIPS.map((c, i) => (
          <button key={c} type="button" onClick={() => setReason(reason === c ? "" : c)} data-testid={`${testId}-chip-${i}`}
            className={`rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${reason === c ? "border-red-300 bg-red-50 text-red-700" : "border-slate-200 bg-slate-50 text-slate-600 hover:bg-slate-100"}`}>
            {c}
          </button>
        ))}
      </div>
      <Textarea rows={2} maxLength={MAX} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Or write your own explanation…"
        className="resize-none text-sm" data-testid={`${testId}-input`} />
      <div className="mt-2 flex items-center justify-between gap-2">
        <span className="text-[11px] tabular-nums text-slate-400" data-testid={`${testId}-count`}>{reason.length}/{MAX}</span>
        <div className="flex gap-2">
          <Button type="button" size="sm" variant="ghost" disabled={busy} onClick={onCancel} data-testid={`${testId}-cancel`}><X className="mr-1 h-3.5 w-3.5" /> Cancel</Button>
          <Button type="button" size="sm" className="rounded-full bg-red-600 hover:bg-red-700" disabled={busy} onClick={() => onSend(reason.trim())} data-testid={`${testId}-send`}>
            {busy && <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />} Send decline
          </Button>
        </div>
      </div>
    </div>
  );
}
